const moderators = [
  'e68bea05-e2cf-4783-8480-409ab42a664e',
  '42ddfdd4-0365-4af5-bbaa-832f0ac6b41b',
  '82e2f507-96b6-453a-9f63-2fe65643fb72',
  'd7e2d167-1ac2-46e0-a27d-89a55d77208d',
]

export default moderators
